import { cn } from '@/utils/cn'

type BadgeVariant = 'success' | 'warning' | 'error' | 'info' | 'neutral'

interface BadgeProps {
  label: string
  variant?: BadgeVariant
  className?: string
}

const VARIANT_STYLES: Record<BadgeVariant, string> = {
  success: 'bg-[rgba(34,197,94,0.1)] text-[var(--success)] border-[rgba(34,197,94,0.3)]',
  warning: 'bg-[rgba(224,123,16,0.1)] text-[var(--accent2)] border-[rgba(224,123,16,0.3)]',
  error:   'bg-[rgba(220,38,38,0.1)] text-[var(--error)] border-[rgba(220,38,38,0.3)]',
  info:    'bg-[rgba(61,142,240,0.1)] text-[var(--accent)] border-[rgba(61,142,240,0.3)]',
  neutral: 'bg-[var(--surface3)] text-[var(--text-muted)] border-[var(--border)]',
}

/**
 * A small pill-shaped status badge. Used in tables, section headers, etc.
 */
export function Badge({ label, variant = 'neutral', className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-[3px] rounded-[8px] border',
        'text-[9px] font-bold uppercase tracking-[1px]',
        VARIANT_STYLES[variant],
        className
      )}
    >
      {label}
    </span>
  )
}
